/**
 * Brand tokens, and a theme the module does NOT install.
 *
 * The three MUI hosts each build their own `ThemeProvider`, and every component in this
 * package styles itself from theme tokens — `primary.main`, `divider`, `text.secondary`,
 * `background.paper` — rather than from hard-coded colours. That is what lets the same
 * screens look native in ICRM, Assets and Accounts without a per-host fork, and it is why
 * `InventoryModule` does not wrap its children in a `ThemeProvider`: doing so would
 * override the host's typography, density and dark mode with ours.
 *
 * `createInventoryTheme()` exists for exactly two callers: the standalone Inai Inventory
 * service (slice 9), which has no host to inherit from, and a Storybook or test harness.
 */
import { createTheme } from '@mui/material/styles';
/** The suite palette. Confirmed identical across ICRM, Assets and Accounts. */
export const BRAND = {
    primary: '#5A2EE6',
    secondary: '#F7941D',
};
/**
 * Semantic colours for stock states and count variances.
 *
 * Resolved against the host's palette rather than fixed, so a host in dark mode gets its
 * own error red rather than ours.
 */
export function stockStateColor(theme, state) {
    switch (state) {
        case 'AVAILABLE':
            return theme.palette.success.main;
        case 'IN_TRANSIT':
            return theme.palette.info.main;
        case 'QUARANTINE':
            return theme.palette.warning.main;
    }
}
export function createInventoryTheme(options = {}) {
    return createTheme({
        ...options,
        palette: {
            primary: { main: BRAND.primary },
            secondary: { main: BRAND.secondary },
            ...options.palette,
        },
        shape: { borderRadius: 10, ...options.shape },
    });
}
//# sourceMappingURL=theme.js.map